import { assign, createMachine } from "xstate";
import { IScope } from "@nju/scope";

export type INumberDecisionType = "EXISTING" | "NEW";

interface IContext {
  numberDecisionMethod?: INumberDecisionType;
  errorMessage?: string;
  variant: IScope;
}

type IEvent =
  | { type: "SET_NUMBER_DECISION"; value: INumberDecisionType }
  | { type: "SUBMIT" }
  | {
      type: "SUCCESS";
    }
  | { type: "FAILED" };

export const selectNewOrExistingNumberMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          SET_NUMBER_DECISION: {
            actions: "setNumberDecision",
          },
          SUBMIT: [
            {
              cond: "isNewNumberSet",
              actions: "redirectToChooseNewNumberPage",
              target: "goToNextStep",
            },
            {
              cond: "isExistingNumberSet",
              actions: "redirectToMigrateNumberPage",
              target: "goToNextStep",
            },
            {
              actions: "setErrorMessage",
            },
          ],
        },
      },
      goToNextStep: {
        type: "final",
      },
      error: {
        type: "final",
      },
    },
  },
  {
    actions: {
      setNumberDecision: assign((context, event: IEvent) => {
        if (event.type === "SET_NUMBER_DECISION") {
          return {
            numberDecisionMethod: event.value,
            errorMessage: undefined,
          };
        }

        return context;
      }),
      setErrorMessage: assign((context, __: IEvent) => {
        const message =
          context.variant !== "sales"
            ? "Aby przejść dalej, wybierz, co chcesz zrobić."
            : "Aby przejść dalej, wybierz, co chce zrobić klient.";
        return {
          errorMessage: message,
        };
      }),
    },
    guards: {
      isNewNumberSet: ({ numberDecisionMethod }) => {
        return numberDecisionMethod === "NEW";
      },
      isExistingNumberSet: ({ numberDecisionMethod }) => {
        return numberDecisionMethod === "EXISTING";
      },
    },
  },
);
